// extracted by mini-css-extract-plugin
module.exports = {"loading":"UyJUHZ"};